import { CALENDAR_CONFIG } from '../config/constants.js'
import { BOOKING_CARD_MARKER, stripBookingPlaceholders } from './booking-markdown.js'

const BOOKING_URL = CALENDAR_CONFIG.DEFAULT_LINK

const BOOKING_MENTION_REGEX =
  /\b(?:booking\s*link|bestillingslenke|schedule\s*(?:a\s+)?(?:call|meeting|time)|book\s+(?:a\s+)?(?:call|meeting|time|slot)|here(?:'s| is)\s+(?:the|your|a)\s+link|book\s+(?:directly|a call)|using this link|book a call right here|gratis\s+samtale|neste\s+steg|første\s+steg|forste\s+steg|åpne\s+kalender|apne\s+kalender|planlegg\s+et\s+møte|planlegg\s+et\s+mote)\b/i

function bookingAnchorLabel(text: string): string {
  if (/[æøå]/i.test(text) || /\b(samtale|kalender|steg|møte|mote)\b/i.test(text)) return 'Åpne kalender'
  return 'Book a time with Farzad'
}

const HAS_SCHEDULING_URL_REGEX = /https?:\/\/\S*(?:cal\.com|calendly\.com)\S*/i

/**
 * If the assistant mentions booking/scheduling but omits a URL, append the Cal.com link
 * with the booking-card marker so the UI renders FutureCalendarWidget instead of a raw link.
 */
export function ensureBookingLink(text: string, bookingUrl: string = BOOKING_URL): string {
  if (!text) return text

  const cleaned = stripBookingPlaceholders(text)
  const hasMarker = cleaned.includes(BOOKING_CARD_MARKER)
  if (HAS_SCHEDULING_URL_REGEX.test(cleaned) && !hasMarker) {
    return `${cleaned.trimEnd()}\n\n${BOOKING_CARD_MARKER}`
  }

  if (!BOOKING_MENTION_REGEX.test(cleaned) && !BOOKING_MENTION_REGEX.test(text)) return cleaned
  if (/https?:\/\/\S+/i.test(cleaned)) return cleaned

  return `${cleaned.trimEnd()}\n\n[${bookingAnchorLabel(cleaned)}](${bookingUrl})\n\n${BOOKING_CARD_MARKER}`
}

export function formatBookingLinkResponse(
  intro = 'Absolutely — here is the link to book time with Farzad:',
  bookingUrl: string = BOOKING_URL,
): string {
  return `${intro}\n\n[Book a time with Farzad](${bookingUrl})\n\n${BOOKING_CARD_MARKER}`
}
